import React, { useEffect, useState, useRef } from 'react'
import ExcelExport from '../ExcelExport'
import { Link, useNavigate } from 'react-router-dom';
import { optionProductsByProducts } from '../Options';
import Multiselect from 'multiselect-react-dropdown';
import Sidebar from '../Sidebar';
// import env from 'react-dotenv'

export default function WheatTable() {

    const [prices, setPrices] = useState([])
    const [search, setSearch] = useState('')
    const [filteredPrices, setFilteredPrices] = useState([]);
    const [todate, setTodate] = useState('')
    const [fromdate, setFromdate] = useState('')
    const [todateformat, setTodateformat] = useState('')
    const [fromdateformat, setFromdateformat] = useState('')
    const [disable, setDisable] = useState(false)
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [todayMessage, setTodayMessage] = useState("Today's values")
    const [dateDesign, setDateDesign] = useState('')
    const [sortedPrices, setSortedPrices] = useState([])
  
     //CHECK FOR THE VALUE
   const [todayCheck, setTodayCheck] = useState(false)
   const handleTodayCheck = () =>{
    // console.log("State prior to changing " +todayCheck)
     if(todayCheck === false){
       setTodayCheck(true)
       setTodayMessage('All values')
       setDisable(true)
     }
     else{
       setTodayCheck(false)
       setTodayMessage("Today's values")
       setDisable(false)
     }
   } 
   useEffect(()=>{
    // console.log("The state now :" + todayCheck)
   }, [todayCheck])

     //Pagination
    const [page, setPage] = useState(1)
    const [postsPerPage, setPostsPerPage] = useState(20)
    const getPrices = async ()=> {
      const token = sessionStorage.getItem('token')
        const response = await fetch(`${process.env.REACT_APP_API_URL}/getWheatPrices`,{
          headers: {
            'x-access-token': token
          }
        })
        const pricelist = await response.json()
        pricelist.sort((a, b) => {
          const dateA = new Date(a.date);
          const dateB = new Date(b.date);
          return dateB- dateA;
        });
        setPrices(pricelist)
       // console.log(prices)
    }

    const totalPages = Math.ceil(filteredPrices.length / postsPerPage);
    const pageRange = 10; // Number of page buttons to show at a time

    const startPage = Math.max(1, page - Math.floor(pageRange / 2));
    const endPage = Math.min(totalPages, startPage + pageRange - 1);

    const pageButtons = [...Array(endPage - startPage + 1)].map((_, i) => startPage + i);
    useEffect(()=>{
        getPrices()
    }, [])

    
    const lastPostIndex = page*postsPerPage
    const firstPostIndex = lastPostIndex - postsPerPage
    const currentPrices = filteredPrices.slice(firstPostIndex, lastPostIndex)
    const selectPageHandler =(selectedPage)=>{
      setPage(selectedPage)
    }

    

    //handle to date -
    const handletodate = (e) => {
        const edate = e.target.value
        setTodate(new Date(edate).toLocaleDateString('en-US'))
        setTodateformat(edate)
    }
    useEffect(()=>{
       // console.log("Here is the selected end date " + todate + "Original format: " + todateformat)
       // console.log(new Date(todate))
    }, [todateformat])

    //handle from date
    const handlefromdate = (e) => {
          const sdate = e.target.value
        setFromdate(new Date(sdate).toLocaleDateString('en-US'))
        setFromdateformat(sdate)
              
    }
    useEffect(()=>{
       // console.log("Here is the selected start date " + fromdate + ". Original format: "+ fromdateformat+ " Disable status: " + disable)
    }, [fromdate])


    const filterItemsByToday = (items, dateProperty) => {
      const today = new Date();
      today.setHours(0, 0, 0, 0); // Set time to start of today
    
      const filteredItems = items.filter((item) => {
        const itemDate = new Date(item[dateProperty]);
        const itemDateWithoutTime = new Date(itemDate.getFullYear(), itemDate.getMonth(), itemDate.getDate()); // Remove time component
        return itemDateWithoutTime.getTime() === today.getTime(); // Compare dates without time
      });
    
     // console.log('Filtered Items:', filteredItems); // Log the filtered items
      return filteredItems;
    };
    
    useEffect(() => {
      filterItemsByToday(prices, 'date');
    }, [todayCheck]);
    

// Todays Stuff//
const filterData = () => {
  if (todayCheck === false) {
    const selectedProductNames = selectedProducts.map((product) => product.name.toLowerCase());

    if (selectedProductNames.length === 0) {
      // If no products are selected, show all the prices within the date range
      const filteredData = prices.filter((price) => {
        const isDateInRange =
          (!fromdateformat || new Date(price.date) >= new Date(fromdateformat)) &&
          (!todateformat || new Date(price.date) <= new Date(todateformat));
        return isDateInRange;
      });
      
      setFilteredPrices(filteredData);
    } else {
      const filteredData = prices.filter((price) => {
        const priceByProductLowerCase = price.by_product.toLowerCase();
        const isSearchMatch = selectedProductNames.includes(priceByProductLowerCase);
        const isDateInRange =
          (!fromdateformat || new Date(price.date) >= new Date(fromdateformat)) &&
          (!todateformat || new Date(price.date) <= new Date(todateformat));
        return isSearchMatch && isDateInRange;
      });

      
      setFilteredPrices(filteredData);
    }
  } else if(todayCheck === true) {
    const todayItems = filterItemsByToday(prices, 'date');
    setFilteredPrices(todayItems);
    // setFilteredPrices([...todayItems].sort((a,b) => new Date(b.date) - new Date(a.Date)));
  }
};

// Initial state setup and filtering logic
useEffect(() => {
  // Call the function to set the initial filtered data with all prices
  setFilteredPrices(prices);
}, [prices]);

// Handle todayCheck changes and filter accordingly
useEffect(() => {
  filterData();
}, [todayCheck]);

// Handle other filter options changes
useEffect(() => {
  filterData();
}, [selectedProducts, fromdateformat, todateformat, todayCheck]);

    //The Delete Button
    const handleDelete = async (itemId) =>{
      const token = sessionStorage.getItem('token')
      const fL = filteredPrices.filter((filteredPrice) => filteredPrice._id !== itemId)
      await fetch(`${process.env.REACT_APP_API_URL}/delete/${itemId}`,{
          method:'DELETE',
          headers: {
              'Content-Type':'application/json',
              'x-access-token':token
          }
      })
    setFilteredPrices(fL)
  }

  //edit page
  const navigate = useNavigate()
  //Edit page
  const handleEdit = async (itemId) =>{
    navigate(`/update/${itemId}`)
   // console.log("In the button")
  }

  function formatDate(date) {
    const months = [
      'January', 'February', 'March', 'April', 'May', 'June', 
      'July', 'August', 'September', 'October', 'November', 'December'
    ];
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  
    const day = date.getDate();
    const monthIndex = date.getMonth();
    const year = date.getFullYear();
  
    const dayOfWeek = days[date.getDay()]; // Get day of the week
    const month = months[monthIndex]; // Get month name
  
    const formattedDateString = `${dayOfWeek}, ${day}${getDaySuffix(day)} ${month} ${year}`;
  
    return formattedDateString;
  }
  
  function getDaySuffix(day) {
    if (day >= 11 && day <= 13) {
      return 'th';
    }
    const lastDigit = day % 10;
    if (lastDigit === 1) {
      return 'st';
    } else if (lastDigit === 2) {
      return 'nd';
    } else if (lastDigit === 3) {
      return 'rd';
    }
    return 'th';
  }
  


  return (
    <>
   <div className="sidebar">
      <Sidebar/>
      </div>
        <div id='tabler'>
          
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <h1>Commodity Prices</h1>
        <div style={{ marginBottom: '10px', padding:"30px 10px 30px 10px"}}>
          <ExcelExport excelData={filteredPrices} fileName={'PricesSheet'} />
        </div>
        

        <div style={{ marginBottom: '10px', padding:"30px 10px 30px 10px"}}>
        <Link to='/wheat-input'> <button type="button" class="btn btn-secondary">  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-plus-square-fill" viewBox="0 0 16 16">
  <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6.5 4.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3a.5.5 0 0 1 1 0z"/>
</svg>   Create New</button></Link>
        </div>               
      </div>


      {/* <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
  <h1>Commodity Prices</h1>
  <div style={{ marginBottom: '10px', padding: '30px 30px 30px 30px', display: 'flex', gap: '10px' }}>
    <ExcelExport excelData={filteredPrices} fileName={'PricesSheet'} />
    <button type="button" className="btn btn-dark" onClick={() => handleTodayCheck()}>  {todayMessage}</button>
  </div>
</div> */}

        {/**Form for different filters */}
       {!todayCheck &&  <form>
        
        <div class="container">
        <div class="mb-3">
            <label for="formGroupExampleInput2" class="form-label">Product</label>
            <Multiselect 
              options={optionProductsByProducts}
              displayValue='name' 
              selectedValues={selectedProducts}
              onSelect={(selectedList) => setSelectedProducts(selectedList)}
              onRemove={(selectedList) => setSelectedProducts(selectedList)}
              closeOnSelect={false}
              avoidHighlightFirstOption
            />
            {/* Render the filteredPrices here */}
            {/* You can use the filteredPrices state to display the filtered data */}
          </div>
          
          <div class="row"> 
            <div class="col">
              <div class="mb-3">
                <label for="formGroupExampleInput2" class="form-label">From</label>
                <input
                  type="date"
                  class="form-control"
                  id="formGroupExampleInput2"
                  onChange={handlefromdate}
                />
              </div>
            </div>
            <div class="col">
              <div class="mb-3">
                <label for="formGroupExampleInput2" class="form-label">To</label>
                <input
                  type="date"
                  class="form-control"
                  id="formGroupExampleInput2"
                  onChange={handletodate}
                />
              </div>
            </div>
            
          </div>
        </div>
      
        
      </form>}
      {todayCheck && <div>
<h3 style={{color: "gray"}}>Commodity prices for {formatDate(new Date())}</h3>
{/* <div class="alert alert-dark" role="alert">
Showing values for <strong>today.</strong>
</div> */}
</div>}




      <table class="table" id="table1">

  <thead>
    <tr>
      <th scope="col" id='field1'>Date</th>
      {/* <th scope="col">Price_id</th> */}
      <th scope="col">Product</th>
      <th scope="col">By Product</th>
      <th scope="col">Province</th>
      <th scope="col">District</th>
      <th scope="col">Station</th>
      <th scope="col">Minimum</th>
      <th scope="col">Maximum</th>
      <th scope="col">Arrivals</th>
      <th scope="col">Delete</th>
      <th scope="col">Edit</th>
    </tr>
  </thead>

  <tbody>
  
      {currentPrices && currentPrices.map((price, index) =>(
            <tr key={price._id}>
                <th scope="row">{new Date(price.date).toLocaleDateString('en-US')}</th>
                {/* <th>{price._id}</th> */}
                <td  style={{borderRight:"1px black"}}>{price.product}</td>
                <td>{price.by_product}</td>
                <td>{price.province}</td>
                <td>{price.district}</td>
                <td>{price.station}</td>
                <td>{price.minimum}</td>
                <td>{price.maximum}</td>
                <td>{price.arrivals}</td>
                <td><button type="button" class="btn btn-danger" onClick={()=>handleDelete(price._id)}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16"><path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6Z"/> <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1ZM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118ZM2.5 3h11V2h-11v1Z"/></svg></button></td>
                <td>  <Link type="button" class="btn btn-info" to={`/update/${price._id}`}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pencil-square" viewBox="0 0 16 16"><path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/><path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/></svg></Link></td>
            </tr>
      ))}
  </tbody>
  
</table>


{currentPrices.length > 0 && (
  <div className="pagination">
    <br />
    {pageButtons.map((pageNumber) => (
      <button
        type="button"
        id="num-but"
        class="btn btn-secondary btn-lg mb-2"
        onClick={() => selectPageHandler(pageNumber)}
        key={pageNumber}
      >
        {pageNumber}
      </button>
    ))}
    <br />
    {/**Fixing the date issue */}
  </div>
)}
{!prices && <div class="alert alert-primary" role="alert">
  Oops! Something went wrong.
</div>}


    </div>
    
    </>
    
  )


  
}
